import { notifyError } from "./CustomNotifcations";
import { store2 } from "../index";

let isSessionExpired = false; // ✅ MOVE OUTSIDE

export const apiFetch = async (url, options = {}) => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const fullUrl = url.startsWith("http") ? url : `${baseUrl}${url}`;

  const headers = {
    Accept: "application/json",
    ...options.headers,
  };

  try {
    const response = await fetch(fullUrl, {
      ...options,
      headers,
      credentials: "include",
    });

    const data = await response.clone().json().catch(() => null);
    if (response.status === 401 || data?.statusCode === "401") {
      if (!isSessionExpired) {
        isSessionExpired = true;
        store2.dispatch(notifyError("Session expired. Please login again."));
        setTimeout(() => {
          localStorage.clear();
          sessionStorage.clear();
          isSessionExpired = false;
        }, 2000);
      }
      return response;
    }

    return response;
  } catch (error) {
    console.error("error", error);
    throw error;
  }
};